import React, { useCallback, useState } from 'react';
import { Table, Space, Tooltip, Spin } from 'antd';
import { 
  TableWrapper, 
  StudentEditModal, 
  StudentDeleteModal, 
  StudentExcelUploadModal,
  StudentHistoryModal,
  B2cMailSendModal, 
  B2cMultiMailSendModal,
  CompanyEditModal, 
  BillB2CRequestModal, 
  BillB2CPublicModal,
  B2cMultiSmsSendModal,
  QuotationMakeModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { TotalStudentMenu } from 'components/atoms';
import { ColumnsType } from 'antd/lib/table/interface';
import { fetcher } from 'services';
import { CarryOutOutlined, WarningOutlined } from '@ant-design/icons'
import { message } from 'antd';
import { MSG } from 'commons/constants';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';

interface FormItemProps {
  info: LectureInfoDto;
  group: string;
  studentList: StudentListDto[];  
  refetch: () => void;
}

const StudentList = ({info, group, studentList, refetch}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();
  const [selected, setSelectd] = useState<number[]>();
  const [company, setCompany] = useState<number>(0);
  const [selectedStudent, setSelectdStudent] = useState<string[]>();
  const [selectedCrm, setSelectdCrm] = useState<string[]>();
  const [isLoding, setIsLoading] = useState<boolean>(false); 

  const onRowClick = (record) => {
    return {
      onClick: () => {
        open(StudentEditModal, { 
          id: record.id,
          group: group,
          lectureInfo: info,
          refetch: refetch,
          onClose: (isOk) => {
            if (isOk) {   
              refetch();
            };
          },          
        }); 
      },
    };
   };

  const columns: ColumnsType<StudentListDto> = [
    {
      title: '번호',
      key: 'num',
      width: '50px',
      align: 'center',
      fixed: 'left',
      onCell: onRowClick,  
      render: (text, record, index) => {
        return (
          index+1
        )
      }        
    },  
    {
      title: '결제수단',
      key: 'ebill_yn',
      dataIndex: 'ebill_yn',
      width: '100px',
      align: 'center',
      fixed: 'left',
      onCell: onRowClick,  
      sorter: (a, b) => {
        const aValue = a.mem_price==0?'장학생':(!!a.bill_type)?a.bill_type:(a.ebill_yn==='Y')?'세금계산서':(a.ebill_yn==='C')?'선납금':(a.ebill_yn==='N')?'카드':(a.ebill_yn==='P')?'포인트':'현금영수증';
        const bValue = b.mem_price==0?'장학생':(!!b.bill_type)?b.bill_type:(b.ebill_yn==='Y')?'세금계산서':(b.ebill_yn==='C')?'선납금':(b.ebill_yn==='N')?'카드':(b.ebill_yn==='P')?'포인트':'현금영수증';

        return aValue.localeCompare(bValue)
      },      
      render: (ebill_yn, record) => {
        return (
          record.mem_price==0?'장학생':(!!record.bill_type)?record.bill_type:(ebill_yn==='Y')?'세금계산서':(ebill_yn==='C')?'선납금':(ebill_yn==='N')?'카드':(ebill_yn==='P')?'포인트':'현금영수증'
        )
      }        
    }, 
    {
      title: '발행일자',
      key: 'bill_date',
      dataIndex: 'bill_date',
      width: '100px',
      align: 'center',
      fixed: 'left',
      sorter: (a, b) => {
        const aValue = a.bill_date ? a.bill_date : a.ebill_etc ? a.ebill_etc : '';
        const bValue = b.bill_date ? b.bill_date : b.ebill_etc ? b.ebill_etc : '';

        return aValue.localeCompare(bValue)
      },
      onCell: onRowClick,  
      render: (bill_date, record) => {
        return (
          (record.bill_price===record.mem_price)?<a onClick={(e) => {
            e.stopPropagation();
          }}><label style={{color:'black'}}>{record.mem_price==0?record.ebill_etc:bill_date}</label></a>:<label style={{color:'red'}}>{record.ebill_etc}</label>
        )
      }        
    },      
    {
      title: '교육비 (vat 포함)',
      dataIndex: 'mem_price',
      key: 'mem_price',
      width: '150px',
      align: 'right',
      fixed: 'left',
      sorter: (a, b) => a.mem_price - b.mem_price,
      onCell: onRowClick,  
      render: (mem_price, record) => {
        const price = mem_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' ('+(mem_price*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+')';
        return (
          <a onClick={(e) => {
            e.stopPropagation();
            if (record.mem_price > 0) {
              if (record.bill_price===record.mem_price) {
                open(BillB2CPublicModal, {
                  id: record.bill_id,
                  onClose: (isOk) => {
                    if (isOk) {}
                  },
                }); 
              } else {
                open(BillB2CRequestModal, {
                  id: record.group_id,
                  student_id: record.id,
                  onClose: (isOk) => {
                    if (isOk) {refetch()}
                  },
                });  
              }
            }
          }}>
            <label style={{color:(record.mem_price > 0 && record.bill_price!==record.mem_price)?'red':'black'}}>{price}</label>
          </a>
        )
      }       
    },     
    {
      title: '포인트매출',
      dataIndex: 'bill_point',
      key: 'bill_point',
      width: '80px',
      align: 'right',
      fixed: 'left',
      sorter: (a, b) => a.bill_point - b.bill_point,
      onCell: onRowClick,  
      render: (bill_point) => {
        return (
          bill_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )
      }    
    },     
    {
      title: '회사명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '130px',
      align: 'center', 
      ellipsis: true,  
      fixed: 'left', 
      sorter: (a, b) => a.company_name.localeCompare(b.company_name),
      onCell: onRowClick,  
      render: (company_name, record) => {
        return record.company_srl && record.edu_srl?
          <a onClick={(e) => {
            e.stopPropagation();
            open(CompanyEditModal, {
              id: record.company_srl,
              isPopup: true,
              onClose: (isOk) => {if(isOk) refetch();},
            }); 
          }}>
            <label style={{color:'black'}}>{company_name}</label>
          </a>:<label style={{color:'red'}}>{company_name}</label>        
      }          
    },  
    {
      title: '부서명',
      dataIndex: 'department',
      key: 'department',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,
      onCell: onRowClick,  
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: '이름',
      dataIndex: 'name_kor',
      key: 'name_kor',
      width: '90px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,  
      onCell: onRowClick,  
      sorter: (a, b) => a.name_kor.localeCompare(b.name_kor),
      render: (name_kor, record) => {
        return (
          <>
            {(record.memo)?(
              <Tooltip placement="topLeft" title={record.memo}>
                <CarryOutOutlined />&nbsp;{name_kor}
              </Tooltip>
              
            ):(name_kor)}
            {(record.memo3 !== '0')&&(<WarningOutlined style={{color:"red",marginLeft:"5px"}} />)}
          </>
        )
      }  
    }, 
    {
      title: '직위',
      dataIndex: 'position',
      key: 'position',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,
      sorter: (a, b) => {
        const aValue = a.position?a.position:'';
        const bValue = b.position?b.position:'';

        return aValue.localeCompare(bValue)
      },       
      onCell: onRowClick,  
    },
    {
      title: '직책',
      dataIndex: 'duty',
      key: 'duty',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,  
      sorter: (a, b) => {
        const aValue = a.duty?a.duty:'';
        const bValue = b.duty?b.duty:'';

        return aValue.localeCompare(bValue)
      },           
      onCell: onRowClick,  
    },          
    {
      title: '휴대폰',
      dataIndex: 'phone',
      key: 'phone',
      width: '100px',
      align: 'center',
      ellipsis: true,  
      onCell: onRowClick,  
      sorter: (a, b) => {
        const aValue = a.phone?a.phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`):'';
        const bValue = b.phone?b.phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`):'';

        return aValue.localeCompare(bValue)
      },       
      render: (phone) => {
        return (
          phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
        )
      } 
    },    
    {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '150px',
     align: 'center',
     ellipsis: true, 
      sorter: (a, b) => {
        const aValue = a.email?a.email:'';
        const bValue = b.email?b.email:'';

        return aValue.localeCompare(bValue)
      },         
     onCell: onRowClick,  
   },
  {
    title: '메일발송현황',
    children: [
      {
        title: '교육담당자',
        dataIndex: 'mail_type06',
        key: 'mail_type06',
        width: '80px',
        align: 'center',
        sorter: (a, b) => {
          const aValue = a.mail_type06?a.mail_type06:'';
          const bValue = b.mail_type06?b.mail_type06:'';

          return aValue.localeCompare(bValue)
        },          
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type06', 0, false);
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type06_status==='40'?'#d9363e':record.mail_type06_status==='20'?'#52c41a':record.mail_type06_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }         
      },  
      {
        title: '신청확인',
        dataIndex: 'mail_type07',
        key: 'mail_type07',
        width: '80px',
        align: 'center',
        sorter: (a, b) => {
          const aValue = a.mail_type07?a.mail_type07:'';
          const bValue = b.mail_type07?b.mail_type07:'';

          return aValue.localeCompare(bValue)
        },         
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type07', 0, false);
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type07_status==='40'?'#d9363e':record.mail_type07_status==='20'?'#52c41a':record.mail_type07_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },  
      {
        title: '참석안내',
        dataIndex: 'mail_type09',
        key: 'mail_type09',
        width: '80px',
        align: 'center',
        sorter: (a, b) => {
          const aValue = a.mail_type09?a.mail_type09:'';
          const bValue = b.mail_type09?b.mail_type09:'';

          return aValue.localeCompare(bValue)
        },         
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type09', 0, false);
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type09_status==='40'?'#d9363e':record.mail_type09_status==='20'?'#52c41a':record.mail_type09_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },    
      {
        title: '현황공유',
        dataIndex: 'mail_type12',
        key: 'mail_type12',
        width: '80px',
        align: 'center',
        sorter: (a, b) => {
          const aValue = a.mail_type12?a.mail_type12:'';
          const bValue = b.mail_type12?b.mail_type12:'';

          return aValue.localeCompare(bValue)
        },         
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type12', 0, false);
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type12_status==='40'?'#d9363e':record.mail_type12_status==='20'?'#52c41a':record.mail_type12_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },    
      {
        title: '보고서전달',
        dataIndex: 'mail_type13',
        key: 'mail_type13',
        width: '80px',
        align: 'center',
        sorter: (a, b) => {
          const aValue = a.mail_type13?a.mail_type13:'';
          const bValue = b.mail_type13?b.mail_type13:'';

          return aValue.localeCompare(bValue)
        },        
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type13', 0, true);
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type13_status==='40'?'#d9363e':record.mail_type13_status==='20'?'#52c41a':record.mail_type13_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },    
    ]
  },   
  {
   title: '기능',
   key: 'act',
   width: '80px',
   align: 'center',
   ellipsis: true,  
   render: (record) => {
    return (
      <>
        <a onClick={(e) => {
          e.stopPropagation();
          if (record.bill_price > 0) {
            alert("계산서가 발행되어 취소 할 수 없습니다.");
          } else {
            onUserCancel(false, record.id);
          }
        }}>취소</a>&nbsp;|&nbsp;
        <a onClick={(e) => {
          e.stopPropagation();
          if (record.bill_price > 0) {
            alert("계산서가 발행되어 연기 할 수 없습니다.");
          } else {
            onUserCancel(true, record.id);
          }
        }}>연기</a>
      </>
    )
  }      
 },
 {
  title: '담당자명',
  dataIndex: 'edu_name',
  key: 'edu_name',
  width: '80px',
  align: 'center',
  ellipsis: true,    
  onCell: onRowClick,  
  sorter: (a, b) => a.edu_name.localeCompare(b.edu_name),   
},    
{
  title: '담당자직급',
  dataIndex: 'edu_position',
  key: 'edu_position',
  width: '80px',
  align: 'center',
  ellipsis: true,  
  onCell: onRowClick,  
  sorter: (a, b) => a.edu_position.localeCompare(b.edu_position),      
},    
{
  title: '담당자전화',
  dataIndex: 'edu_phone',
  key: 'edu_phone',
  width: '100px',
  align: 'center',
  ellipsis: true,  
  onCell: onRowClick,    
  sorter: (a, b) => {
    const aValue = a.edu_phone?a.edu_phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`):'';
    const bValue = b.edu_phone?b.edu_phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`):'';

    return aValue.localeCompare(bValue)
  },     
  render: (phone) => {
    return (
      phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    )
  } 
},    
{
  title: '담당자이메일',
  dataIndex: 'edu_email',
  key: 'edu_email',
  width: '150px',
  align: 'center',
  ellipsis: true, 
  sorter: (a, b) => {
    const aValue = a.edu_email?a.edu_email:'';
    const bValue = b.edu_email?b.edu_email:'';

    return aValue.localeCompare(bValue)
  },    
  onCell: onRowClick,     
},    
{
  title: '신청일',
  key: 'reg_dttm',
  dataIndex: 'reg_dttm',
  width: '80px',
  align: 'center',
  ellipsis: true,
  onCell: onRowClick,  
  sorter: (a, b) => a.reg_dttm.localeCompare(b.reg_dttm),
}, 
 {
  title: '히스토리',
  dataIndex: 'history',
  key: 'history',
  width: '80px',
  align: 'center',
  ellipsis: true,  
  sorter: (a, b) => a.history - b.history,
  onCell: (record, e) => {
    return {
        onClick: (e) => {
          onHistoryOpen(record.name_kor, record.phone);       
        },
      }
    }
  }
  ];

  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  
  const [selectedRowKeys, setRowKeys] = useState<any>([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: StudentListDto[]) => {
      setRowKeys(selectedRowKeys);
      
      setSelectd(selectedRows.map((item) => item.id));
      setSelectdStudent(selectedRows.map((item) => item.name_kor));
      setSelectdCrm(selectedRows.map((item) => item.edu_name));
      if (selectedRows.length > 0) {
        setCompany(selectedRows[0].company_srl);
      } else {
        setCompany(0)
      }
      
    },
    /*
    getCheckboxProps: (record: StudentListDto) => ({
      disabled: record.bill_price > 0
    }),
    */
  };
  
   const onRegister = () => {
      if (info.close_yn==='Y' || (info.student_max > 0 && info.student_max <= studentList?.length)) {
        if (info.close_yn==='Y') {
          alert('과정이 마감되어 등록 할 수 없습니다.');
        } else {
          alert('설정된 최대 인원을 초과하여 등록 할 수 없습니다.');
        }
        return;
      }

      open(StudentEditModal, { 
        id: 0,
        group: group,
        lectureInfo: info,
        refetch: refetch,
        onClose: (isOk) => {
          if (isOk) {   
            refetch();
          };
        },          
      }); 
   }; 
   

   const onRegisterExcel = () => {
    if (info.close_yn==='Y' || (info.student_max > 0 && info.student_max <= studentList?.length)) {
      if (info.close_yn==='Y') {
        alert('과정이 마감되어 등록 할 수 없습니다.');
      } else {
        alert('설정된 최대 인원을 초과하여 등록 할 수 없습니다.');
      }
      return;
    }

    open(StudentExcelUploadModal, { 
      lectureInfo: info,
      onClose: (isOk) => {
        if (isOk) {   
          refetch();
        };
      },          
    }); 
 };    

   const onUserCancel = (putoff: boolean, id: number) => {          
      if (!!info) {
          open(StudentDeleteModal, {
              lectureInfo: info,
              id: id,
              group: group,
              putoff: putoff,
              onClose: (isOk) => {
                if (isOk) {
                  refetch();
                };
              },
          });  
      }
  }   

  const onSendMail = (id: number, mail_type: string, mail_id: number, use_memo: boolean) => {          
    if (!!info) {
        open(B2cMailSendModal, {
            id: id,
            group: group,
            mail_type: mail_type,
            mail_id: mail_id,
            use_memo: use_memo,
            onClose: (isOk) => {
              if (isOk) {
                refetch();
              };
            },
        });  
    }
  }   

  const onSendMultiMail = (mail_type: string) => {   
    if (!!selected && selected.length > 0) {
        open(B2cMultiMailSendModal, {
            ids: selected.join(','),
            group: group,
            toStudents: selectedStudent?.join(',')+'',
            toCrms: selectedCrm?.join(',')+'', 
            mail_type: mail_type,
            onClose: (isOk) => {
              if (isOk) {
                refetch();
                setRowKeys([]);                
              };
            },
        });  
    } else {
      alert("대상을 선택해 주세요.");
    }
  }  
  
  const onSendMultiSms = () => {   
    if (!!selected && selected.length > 0) {
        open(B2cMultiSmsSendModal, {
            ids: selected.join(','),
            toStudents: selectedStudent?.join(',')+'',
            onClose: (isOk) => {
              if (isOk) {   
                setRowKeys([]);                
              };
            },
        });  
    } else {
      alert("대상을 선택해 주세요.");
    }
  }    

  const onDelete = () => {
    if (!!selected) {
      selected.forEach((id) => {
        fetcher.b2c.postStudentDelete({id: parseInt(id.toString())})
        .then((res) => {
            switch (res.code) {
                case 200:
                  refetch();
                break;
                case 500:
                  alert(MSG.ERROR_ACCOUNT_CLOSE);
                  break;                  
                default:  
                break;
            };
        });
      });
    }
  }

  const onHistoryOpen = (name: string, phone: string) => {          
    open(StudentHistoryModal, {
      name_kor: name,
      phone: phone,
    }); 
  }     

  const onSendQuotation = () => {   
    if (!!selected && selected.length > 0) {
        open(QuotationMakeModal, {
            lectureInfo: info,
            studentCnt: selected.length,
            company: company,
            onClose: (isOk, id) => {
              if (isOk) {
                setRowKeys([]); 
                setSelectd([]);
                onSendMail(id, 'type13', 392, false);
              };
            },
        });  
    } else {
        open(QuotationMakeModal, {
            lectureInfo: info,
            studentCnt: 0,
            company: 0,
            onClose: (isOk, id) => {
              if (isOk) {
                setRowKeys([]); 
                setSelectd([]);
                onSendMail(id, 'type13', 392, false);
              };
            },            
        });  
    }
  }  

  const onNewExcelDownload = () => {
    setIsLoading(true); 
    axios({
      url: SERVER_URL + endpoints.b2c.student.downloadexcel,
      method: 'post',
      responseType: 'arraybuffer',
      params: {id:info.id},
    })
    .then((response) => {
      const fileName = `${info.lecture_title}.xlsx`;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}`);
      link.style.cssText = 'display:none';
      document.body.appendChild(link);
      link.click();
      setIsLoading(false); 
    })
    .catch(() => {
      setIsLoading(false); 
      message.error('파일 다운로드 중 에러가 발생했습니다.', 1);      
    });     
  }    

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
        <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
          <TotalStudentMenu 
            info={info}
            totalNum={studentList?.length} 
            onRegister={onRegister}
            onRegisterExcel={onRegisterExcel}
            onDelete={onDelete}
            onSendCertificate={() => onSendMultiMail("type13")}          
            onSendMail={() => onSendMultiMail("")} 
            onDownloadExcel={onNewExcelDownload}
            onSendQuotation={onSendQuotation}
            onSendSms={onSendMultiSms}
          />
          <TableWrapper isSearch={false}>
            <Table
              tableLayout="fixed"
              scroll={{ x: 1450 }}
              dataSource={studentList}
              columns={columns}
              pagination={false}
              style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
              className="columnCenterFixTable clickable"
              showSorterTooltip={false}
              rowKey={'id'}
              rowSelection={{
                type: 'checkbox',
                ...rowSelection,
              }}            
            />          
          </TableWrapper> 
        </Spin>
    </Space>
  );
};

export default StudentList;
